export default "__VITE_ASSET__046775f2__"